import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { TableContentProperty, UniqueHeaderKey } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import TableCell from '../TableCell.vue';
import { UniqueTableContentViewModel } from './uniqueTableContentViewModel';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'UniqueTableCell',
  props: {
    header: {},
    headerKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isBold: { type: Boolean },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["onClickNarrow"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

const uniqueTableContentVM = new UniqueTableContentViewModel();

const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCell, {
    class: _normalizeClass([[_unref(uniqueTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
    style: _normalizeStyle({
      left: _unref(uniqueTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
      opacity: 0,
    }),
    "text-align": textAlign.value,
    "table-content-property": _ctx.header,
    "tool-tip-value": _unref(uniqueTableContentVM).displayUniqueItem(_ctx.headerKey, _ctx.item),
    "is-highlighted": props.isChecked || props.isCheckedBusinessId
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["table-cell-content", { 'table-cell-content': _ctx.isBold }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickNarrow')))
      }, _toDisplayString(_unref(uniqueTableContentVM).displayUniqueItem(_ctx.headerKey, _ctx.item)), 3)
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "text-align", "table-content-property", "tool-tip-value", "is-highlighted"]))
}
}

})